<template>
    <app-layout>
        <common-content-spacer height="medium">
            <common-content-spacer height="small">
                <common-breadcrumbs :breadcrumbs="pageBreadcrumbs"></common-breadcrumbs>
                <div class="page-header-row">
                    <common-page-header :heading="pageTitle"></common-page-header>
                    <div class="header-actions">
                        <common-button
                            :label="$t('pages.network.connections.buttons.start_now')"
                            size="medium-small"
                            type="primary"
                            @click="openSearchAndAddMembersModal"
                        ></common-button>
                        <common-button
                            :label="$t('pages.network.connections.buttons.send_network_message')"
                            size="small"
                            type="primary"
                            @click="toggleshowEmailForm()"
                        ></common-button>
                        <common-modal v-if="showEmailForm" @close="closeSendNetworkMessageModal()">
                            <email-form
                                :showBccWarning="true"
                                :showOpenSelectMemberModalButton="true"
                                @email-data="sendEmail"
                                @close="toggleshowEmailForm()"
                            ></email-form>
                        </common-modal>
                    </div>
                </div>
            </common-content-spacer>

            <div class="members-header">
                <!--  <div class="search-row">
                    <div class="search-box">
                        <common-icon name="search-gray" size="small" class="search-icon"></common-icon>
                        <input
                            v-model="search"
                            type="text"
                            placeholder="Search and Add members to your network"
                            class="search-input"
                        />
                    </div>
                </div>  -->
                <div class="tabs-row">
                    <div v-show="false" class="toggle-tabs">
                        <button v-for="tab in tabs" :key="tab.name" :class="tab.buttonClass" @click="activeTab = tab.name">
                            <span class="dot" :class="tab.name === 'physicians' ? 'green' : 'blue'"></span>
                            {{ tab.displayName }}
                        </button>
                    </div>
                    <div class="tabs-row__right" style="margin-left: auto">
                        <button
                            class="filter-btn"
                            :class="{ 'filter-btn--active': showFilters }"
                            @click="showFilters = !showFilters"
                        >
                            <common-icon name="filter" size="small"></common-icon>
                            Filters
                        </button>
                        <div class="view-toggle">
                            <div
                                v-for="groupTab in groupTabs"
                                :key="groupTab.name"
                                :class="groupTab.iconClass"
                                @click="viewType = groupTab.name"
                            >
                                <common-icon :name="groupTab.icon" size="large"></common-icon>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <common-page-plain>
                <practice-members-list
                    ref="membersList"
                    :viewType="viewType"
                    :search="search"
                    :showFilters="showFilters"
                ></practice-members-list>
            </common-page-plain>
        </common-content-spacer>
        <search-and-add-members-modal
            :isOpen="isSearchAndAddMembersModalOpen"
            @close="closeSearchAndAddMembersModal"
            @new-connection-added="closeSearchAndAddMembersModal"
        ></search-and-add-members-modal>
    </app-layout>
</template>

<script>
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import PageWithElementsMixin from 'mixins/PageWithElementsMixin'
    import AppLayout from 'components/layouts/AppLayout'
    import PracticeMembersList from 'components/page-elements/practice/PracticeMembersList'
    import SearchAndAddMembersModal from 'components/page-elements/network/SearchAndAddMembersModal'
    import EmailForm from 'components/forms/connections/EmailForm'
    import { openEmailClient } from '~/utils'

    export default {
        mixins: [PageWithTitleMixin, PageWithElementsMixin],

        components: {
            AppLayout,
            PracticeMembersList,
            SearchAndAddMembersModal,
            EmailForm,
        },

        data() {
            return {
                viewType: 'grid',
                search: '',
                activeTab: 'physicians',
                isSearchAndAddMembersModalOpen: false,
                showEmailForm: false,
                showFilters: true,
            }
        },

        computed: {
            tabs() {
                const tabs = [
                    {
                        name: 'physicians',
                        displayName: this.$t('pages.network.connections.tabs.physicians'),
                    },
                ]

                if (!this.$auth.isPracticeAncillary()) {
                    tabs.push({
                        name: 'providers',
                        displayName: this.$t('pages.network.connections.tabs.providers'),
                    })
                }

                return tabs.map((tab) => ({
                    ...tab,
                    buttonClass: {
                        'toggle-btn': true,
                        active: this.activeTab === tab.name,
                    },
                }))
            },

            pageTitle() {
                return this.$t('pages.practice.members.titles.practice_members', { practiceName: this.$auth.getPractice().name })
            },

            groupTabs() {
                return [
                    { name: 'grid', icon: 'grid', class: 'toggle-icon-left' },
                    { name: 'list', icon: 'list', class: 'toggle-icon-right' },
                ].map((tab) => ({
                    ...tab,
                    iconClass: {
                        'toggle-icon': true,
                        [tab.class]: true,
                        active: this.viewType === tab.name,
                    },
                }))
            },

            pageBreadcrumbs() {
                return [
                    {
                        label: this.$t('pages.practice.members.breadcrumbs.practice'),
                        route: { name: 'practice.members' },
                    },
                    {
                        label: this.$t('pages.practice.members.breadcrumbs.practice_members'),
                    },
                ]
            },
        },

        methods: {
            openSearchAndAddMembersModal() {
                this.isSearchAndAddMembersModalOpen = true
            },
            closeSearchAndAddMembersModal() {
                this.isSearchAndAddMembersModalOpen = false
                this.refreshMembersList()
            },
            refreshMembersList() {
                if (this.$refs.membersList) {
                    this.$refs.membersList.fetchPracticeMembers({
                        limit: this.$route.query.limit,
                        offset: 0,
                    })
                }
            },
            toggleshowEmailForm() {
                this.showEmailForm = !this.showEmailForm
            },
            closeSendNetworkMessageModal() {
                this.showEmailForm = false
            },
            sendEmail(event) {
                openEmailClient({
                    to: event.to,
                    cc: event.cc,
                    bcc: event.bcc,
                    subject: event.subject,
                    message: event.message,
                })
            },
        },
    }
</script>

<style lang="scss" scoped>
    .page-header-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;

        @media (max-width: 767px) {
            flex-direction: column;
            align-items: flex-start;
            gap: 12px;
        }
    }

    .header-actions {
        display: flex;
        align-items: center;
        gap: 12px;

        @media (max-width: 767px) {
            width: 100%;
            flex-wrap: wrap;
        }
    }

    .members-header {
        margin-bottom: 20px;
    }

    .tabs-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 16px;

        @media (max-width: 767px) {
            flex-direction: column;
            align-items: stretch;
            gap: 12px;
        }

        &__right {
            display: flex;
            align-items: center;
            gap: 12px;

            @media (max-width: 767px) {
                justify-content: space-between;
            }
        }
    }

    .filter-btn {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.7rem 1rem;
        border: 1px solid #d1d5db;
        border-radius: 0.625rem;
        background: #fff;
        font-size: 14px;
        font-weight: 500;
        color: #374151;
        cursor: pointer;
        transition: all 0.2s ease;
        white-space: nowrap;

        &:hover {
            background: #d1d5db;
        }

        &--active {
            border-color: #d1d5db;
        }
    }

    .toggle-tabs {
        display: inline-flex;
        background: #f3f4f6;
        padding: 0.25rem;
        border-radius: 0.5rem;

        @media (max-width: 767px) {
            width: 100%;
        }
    }

    .toggle-btn {
        border: none;
        background: transparent;
        padding: 8px 18px;
        border-radius: 0.5rem;
        font-size: 14px;
        font-weight: 500;
        line-height: 2;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 8px;
        color: oklch(0.145 0 0);
        width: 210px;
        justify-content: center;
        transition: all 0.3s ease;

        @media (max-width: 767px) {
            width: auto;
            flex: 1;
            padding: 8px 12px;
            font-size: 13px;
        }

        &.active {
            background: #fff;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
        }
    }

    .dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;

        &.green {
            background: #22c55e;
        }

        &.blue {
            background: #3b82f6;
        }
    }

    .search-row {
        display: flex;
        align-items: center;
        gap: 12px;
    }

    .search-box {
        flex: 1;
        position: relative;
        display: flex;
        align-items: center;

        .search-icon {
            position: absolute;
            left: 12px;
            top: 50%;
            transform: translateY(-50%);
            pointer-events: none;
        }

        .search-input {
            width: 100%;
            padding: 1rem 16px 0.75rem 2.5rem;
            border: 1px solid #e5e7eb;
            border-radius: 0.5rem;
            background: #ffffff;
            font-size: 14px;
            color: #374151;
            outline: none;
            transition: border-color 0.2s ease;

            @media (max-width: 480px) {
                padding: 0.75rem 12px 0.75rem 2.25rem;
                font-size: 13px;
            }

            &::placeholder {
                color: #9ca3af;
            }

            &:focus {
                border: 2px solid #00bcd4;
                border-radius: 0.5rem;
            }
        }
    }

    .view-toggle {
        display: flex;
        gap: 0.25rem;
        background-color: oklch(96.7% 0.003 264.542);
        border-radius: 0.5rem;
        padding: 0.25rem;
        align-items: center;

        @media (max-width: 767px) {
            display: none;
        }
    }

    .toggle-icon {
        padding: 4px;
        cursor: pointer;
        min-width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0.375rem;
        background-color: transparent;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        color: #9ca3af;

        &:hover {
            color: #6b7280;
            background-color: #fff;
        }

        &.active {
            background-color: #fff;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
            color: #6b7280;
        }
    }

    @media (max-width: 767px) {
        ::v-deep .page-plain {
            padding: 0;
            border: none;
            background: transparent;
            border-radius: 0;
        }
    }
</style>
